import { render, staticRenderFns } from "./RsaGestioneOspitePrescrizioniListComponent.vue?vue&type=template&id=4665e29b&scoped=true"
import script from "./RsaGestioneOspitePrescrizioniListComponent.vue?vue&type=script&lang=js"
export * from "./RsaGestioneOspitePrescrizioniListComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaGestioneOspitePrescrizioniListComponent.vue?vue&type=style&index=0&id=4665e29b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4665e29b",
  null
  
)

export default component.exports